import processingApplicationQuestionnaires from "./processingApplicationQuestionnaires";
import applicantOrganicCertificationHistoryQuestionnaire from "./applicantOrganicCertificationHistoryQuestionnaire";
import greenhouseQuestionnaire from "./greenhouseQuestionnaire";
import soilAndCropFertilityManagementQuestionnaire from "./soilAndCropFertilityManagementQuestionnaire";
import cropManagementQuestionnaire from "./cropManagementQuestionnaire";
import recordKeepingQuestionnaire from "./recordKeepingQuestionnaire";
import maintenanceOfOrganicIntegrityQuestionnaire from "./maintenanceOfOrganicIntegrityQuestionnaire";

const processingApplicationQuestionnaireService = [
    {
        matcher: 'processingApplicationQuestionnaires',
        reply: config => {
            // const id = /processingApplicationQuestionnaires\/(.*)/.exec(config.url)[1];
            return [200, processingApplicationQuestionnaires];
        }
    },
    {
        matcher: 'applicantOrganicCertificationHistoryQuestionnaires',
        reply: config => {
            // const id = /applicantOrganicCertificationHistoryQuestionnaires\/(.*)/.exec(config.url)[1];
            return [200, applicantOrganicCertificationHistoryQuestionnaire];
        }
    },
    {
        matcher: 'greenhouseQuestionnaires',
        reply: config => {
            return [200, greenhouseQuestionnaire];
        }
    },
    {
        matcher: 'soilAndCropFertilityManagementQuestionnaires',
        reply: config => {
            return [200, soilAndCropFertilityManagementQuestionnaire];
        }
    },
    {
        matcher: 'cropManagementQuestionnaires',
        reply: config => {
            return [200, cropManagementQuestionnaire]
        }
    },
    {
        matcher: 'recordKeepingQuestionnaires',
        reply: config => {
            return [200, recordKeepingQuestionnaire]
        }
    },
    {
        matcher: 'maintenanceOfOrganicIntegrityQuestionnaires',
        reply: config => {
            return [200, maintenanceOfOrganicIntegrityQuestionnaire]
        }
    }
]

export default processingApplicationQuestionnaireService;